import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Building2, Gift, Settings, User } from 'lucide-react';

const navItems = [
  { path: '/dashboard', label: 'Home', icon: LayoutDashboard, exact: true },
  { path: '/dashboard/banking', label: 'Banking', icon: Building2 },
  { path: '/dashboard/loyalty', label: 'Rewards', icon: Gift },
  { path: '/dashboard/settings', label: 'Settings', icon: Settings },
  { path: '/dashboard/kyc', label: 'Profile', icon: User },
];

export const MobileNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (item) => {
    if (item.exact) {
      return location.pathname === item.path;
    }
    return location.pathname.startsWith(item.path);
  };

  return (
    <nav className="mobile-nav lg:hidden" data-testid="mobile-nav">
      <div className="flex justify-around items-center">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item);
          
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`mobile-nav-item ${active ? 'active' : ''}`}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              <Icon className="w-5 h-5" />
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
